import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {
  BalanceItem,
  MonetaryNoDecimalsPeriodValues,
  TrialBalanceItem
} from '@snelstart-ventures/fiscaal/domain-logic';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-trialbalance-read-only',
  templateUrl: './spec-trialbalance-read-only.component.html',
  imports: [
    SharedUiDialogModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    CommonModule,
  ],
  styleUrls: ['./spec-trialbalance-read-only.component.scss']
})
export class SpecTrialbalanceReadOnlyComponent implements OnChanges {

  @Input({ required: true }) public title = {} as string;
  // @Input() public input = this.fb.group<BalanceItem>(({} as BalanceItem));
  @Input({ required: true }) public input!: FormGroup;
  @Input() public dialogVisible = false;
  @Input() public period2Visible = true;
  @Output() public dialogVisibleChange = new EventEmitter<boolean>();
  public inputFg = {} as FormGroup;

  constructor(
    private fb: FormBuilder) {
    this.inputFg = this.fb.group({
      valuePeriod1: null as unknown as number,
      valuePeriod2: null as unknown as number,
      trialBalanceItems: this.fb.array<TrialBalanceItem>([]),
    })
  }

  get trialBalanceItems(): FormArray {
    return this.inputFg.get('trialBalanceItems') as FormArray;
  }

  createFormGroup(item?: FormGroup): FormGroup {
    const periodValue = item?.get('periodValues')?.value as MonetaryNoDecimalsPeriodValues
    return this.fb.group(({
      rgsCode: item ? item?.get('rgsCode') : null as unknown as string,
      account: item ? item?.get('account') : null as unknown as string,
      accountDescription: item ? item?.get('accountDescription') : null as unknown as string,
      periodValues: this.fb.group({
        valuePeriod1: periodValue ? periodValue.valuePeriod1 : null as unknown as number,
        valuePeriod2: periodValue ? periodValue.valuePeriod2 : null as unknown as number,
      }),
      autogenerated: item ? item?.get('autogenerated') : undefined,
    } as TrialBalanceItem));
  }

  ngOnChanges(): void {
    if (!this.input) return;
    this.syncBalanceItemFormGroups(this.input, this.inputFg)
  }

  syncBalanceItemFormGroups(sourceFg: FormGroup, targetFg: FormGroup) {
    targetFg.patchValue(sourceFg.getRawValue(), { emitEvent: false });

    const sourceArray = sourceFg.get('trialBalanceItems') as FormArray;
    const targetArray = targetFg.get('trialBalanceItems') as FormArray;

    while (targetArray.length > sourceArray.length) {
      targetArray.removeAt(targetArray.length - 1);
    }
    for (let i = 0; i < sourceArray.length; i++) {
      const sourceGroup = sourceArray.at(i) as FormGroup;

      if (i < targetArray.length) {
        const targetGroup  = targetArray.at(i) as FormGroup;
        targetGroup.patchValue(sourceGroup.getRawValue(), { emitEvent: false });
      } else {
        const formGroup = this.createFormGroup(sourceGroup)
        targetArray.push(formGroup);
      }
    }
  }
}
